@if (isLoading) {
  <app-loading [text]="'Loading application data'"></app-loading>
} @else {
  <div class="ma-page">
    <div class="ma-grid">
      @for (card of assetCards; track card.item.id || card.item.name || $index) {
        <article
          class="ma-card"
          [class.ma-card--disabled]="!card.item.alreadyMapped"
        >
          <div class="ma-card__header">
            <div
              class="ma-card__avatar"
              [style.background-color]="card.avatarColor"
              aria-hidden="true"
            >
              <span class="ma-card__avatar-letter">{{ card.initial }}</span>
            </div>

            <div class="ma-card__header-content">
              <div class="ma-card__title-row">
                <h3 class="ma-card__title">{{ card.item.displayName }}</h3>
                <nz-switch
                  class="ma-card__switch"
                  nzSize="small"
                  [(ngModel)]="card.item.alreadyMapped"
                  (ngModelChange)="onToggleAsset(card.item, $event)"
                  [nzDisabled]="isSaving"
                  [nzLoading]="isAssetSaving(card.item)"
                  [attr.name]="'selectAssets-' + (card.item.id || $index)"
                  [attr.aria-label]="'Enable ' + card.item.displayName"
                ></nz-switch>
              </div>

              @if (card.capabilities.length) {
                <div class="ma-card__tags">
                  @for (tag of card.capabilities; track tag.label) {
                    <span
                      class="ma-card__tag"
                      [class.ma-card__tag--active]="isCapabilityActive(tag)"
                    >
                      <img
                        class="ma-card__tag-icon"
                        [src]="
                          (isCapabilityActive(tag)
                            ? checkActiveIcon
                            : checkInactiveIcon) | assetUrl
                        "
                        alt=""
                        width="12"
                        height="12"
                      />
                      <span class="ma-card__tag-label">{{ tag.label }}</span>
                    </span>
                  }
                </div>
              }
            </div>
          </div>

          @if (card.description) {
            <p class="ma-card__description">{{ card.description }}</p>
          }

          <button [hidden]="true"
            type="button"
            class="ma-card__manage"
            (click)="onManageAsset(card.item)"
          >
            Manage Asset
          </button>
        </article>
      }
    </div>
  </div>
}
